import { useMemo } from "react";
import ClientApi from "./clientApi";
import useSessionId from "./useSessionId";

function useClientApi() {
    const [sessionId, ] = useSessionId();
    return useMemo(() => new ClientApi(sessionId), [sessionId]);
}

export default useClientApi;
